import { Fragment, ReactElement } from 'react';
import TrainingReportPdfEvaluatorsRow, {
  TrainerItem,
} from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/TrainingReportPdfEvaluatorsRow';
import { ReportColumns } from '@/pages/Reports/DynamicReport/components/ReportTable/utils';
import Table from '@/common/Table';
import TrainingReportPdfDriversTableRow from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/TrainingReportPdfDriversTableRow';
import TrainingReportPdfTableHeader from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/TrainingReportPdfTableHeader';
import { visibleColumns } from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/utils';

const TOOLTIP_PATTERN = /^TOOLTIP::(\{.*\})$/s;

export const parseTrainerItems = (values: Record<string, string> = {}): TrainerItem[] => {
  const match = typeof values?.trainers === 'string' ? values.trainers.match(TOOLTIP_PATTERN) : null;
  if (!match) return [];
  try {
    const { items } = JSON.parse(match[1]);
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
      category: String(item?.category ?? ''),
      evaluator: String(item?.evaluator ?? ''),
      roles: Array.isArray(item?.roles) ? item.roles.map(String) : [],
    }));
  } catch {
    return [];
  }
};

export type TrainingReportPdfDriversTableProps = {
  columns: ReportColumns;
  drivers: Record<string, string>[];
};

const TrainingReportPdfDriversTable = ({ columns, drivers }: TrainingReportPdfDriversTableProps): ReactElement => {
  const driverColumns = visibleColumns(columns);
  return (
    <Table className="TrainingReportPdf-DriversTable" header={<TrainingReportPdfTableHeader columns={columns} keys={driverColumns} />}>
      {drivers.map((values, d) => {
        const trainers = parseTrainerItems(values);
        return (
          <Fragment key={d}>
            <TrainingReportPdfDriversTableRow values={values} keys={driverColumns} />
            {trainers.length > 0 && <TrainingReportPdfEvaluatorsRow items={trainers} colSpan={driverColumns.length} />}
          </Fragment>
        );
      })}
    </Table>
  );
};

export default TrainingReportPdfDriversTable;
